var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 511.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8182B",
    d: "M6.12 427.8C5 402.31 23.34 370.6 53.25 359.01l42.18-.44 1.18 1.19C81.78 379.5 75.68 398.6 72.3 410.7c-5.21 18.59 7.34 33.81 26.8 29.49 13.61-3.03 34.37-10.49 53.67-24.32.09.08.18.16.27.23l-.43 41.9c-10.98 27.46-39.26 47.89-68.09 48.83 3.95-14.53 20.29-47.14-2.58-32.13-16.04 10.52-45.15 26.98-66.71 22.39-7.89-41.18 44.97-85.04 12.91-77.3-7.18 1.74-14.56 4.62-22.02 8.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M509.7 1.28c4.19 3.33 2.2 15.63-2.28 30.26-6.47 21.1-17.48 49.07-20.71 56-10.34 22.16-24.81 46.02-41.89 70.29l-90.67-90.67c24.32-16.98 48.22-31.4 70.34-41.8 6.61-3.11 33.77-13.61 54.78-20.12 14.4-4.46 26.74-6.89 30.43-3.96zm-77.87 174.43c-19.59 26.13-41.75 52.37-64.64 77.09-38.07 41.12-78.25 78.17-111.98 103.77l-1.16 57.92c-.03 1.4-.64 2.7-1.59 3.65l-91.86 91.88c-2.03 2.03-5.23 2.13-7.14.22-1.02-1.02-1.46-2.4-1.35-3.78l.93-90.36c-.15-.12-.3-.25-.44-.39l-57.17-57.14-90.28.93c-1.38.11-2.76-.33-3.78-1.35-1.91-1.91-1.81-5.11.22-7.14l91.87-91.87c.96-.94 2.26-1.55 3.66-1.58l58.95-1.18c23.87-32.68 58.84-70.97 98.06-107.54 26.12-24.36 54.16-47.99 82.09-68.74l95.61 95.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissileIcon);
export default __webpack_public_path__ + "static/media/missile-icon.c7eca43563fc75de76c4345f1e28191a.svg";
export { ForwardRef as ReactComponent };